import { Alert, Flex, Text, ThemeIcon } from '@mantine/core';
import { IconFileSearch } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import EmptyStub from '@/components/ui/EmptyStub';
import Loader from '@/components/ui/Loader';
import { useLocalStore } from '@/hooks/useLocalStore';
import { SidebarNewsStore, SidebarNewsStoreProvider } from '@/stores/local/sidebar/SidebarNewsStore';
import { useDevices } from '@/utils/devices';

import NewsCategories from './NewsCategories';
import NewsList from './NewsList';
import NewsSearch from './NewsSearch';
import NewsSelect from './NewsSelect';

import s from './NewsContent.module.scss';

const NewsContent: React.FC = () => {
  const { isCompactViewport } = useDevices();

  const { id } = useParams();

  const store = useLocalStore(() => new SidebarNewsStore({ organizationId: Number(id) }));

  React.useEffect(() => {
    store.init();
  }, [store]);

  if (store.meta.isError) {
    return (
      <Alert ml="lg" mr="lg" color="red">
        Не удалось загрузить новости
      </Alert>
    );
  }

  if (store.initMeta.isLoading) {
    return <Loader gap={0} fullHeight type="dots" size="xl" text="Ищу новости..." />;
  }

  const isEmptyStub = store.collection.items.length === 0 && !store.meta.isLoading && !store.searchMeta.isLoading;

  return (
    <SidebarNewsStoreProvider store={store}>
      <Flex className={s.root__header} gap="lg" align="center" justify="space-between">
        <NewsSearch />
        <NewsSelect />
      </Flex>
      <NewsCategories />
      {isEmptyStub ? (
        <EmptyStub
          className={s.root__stub}
          picture={
            <ThemeIcon
              size={isCompactViewport ? 72 : 120}
              radius="xl"
              variant={isCompactViewport ? 'transparent' : 'light'}
              gradient={{ from: 'blue', to: 'grape', deg: 135 }}
            >
              <IconFileSearch size={72} />
            </ThemeIcon>
          }
          title="Новостей пока нет"
          description={<Text c="gray">Для данного бизнеса новостей пока нет</Text>}
        />
      ) : (
        <NewsList />
      )}
    </SidebarNewsStoreProvider>
  );
};

export default observer(NewsContent);
